import React, { useState, useRef, useEffect } from 'react';
import {
    Input, TextField, Button, InputLabel, MenuItem, FormControl, Select, Box, FormHelperText, Autocomplete, InputAdornment, IconButton, FormGroup, FormControlLabel, Checkbox
} from '@mui/material';
import { Formik, useFormik } from 'formik';
import * as yup from 'yup';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { BorderStyleRounded, NoPhotography } from '@mui/icons-material';
import { checkCompanyName, getCompanyType, getIntegratedPlayerList } from '../../../redux/authSlice';


const nonEngChar = /[^-A-Za-z0-9_@,.:;{}/&%()'"#*<>!$?+\n ]/;
export const PERSONAL_COMPANY_DETAILS_VALIDATIONS = (dispatch) => yup.object().shape({
    companyName: yup.string().required('Company Name cannot be empty.')
        .test('checkDuplication', 'Company Name already exists', async (value) => {
            try {
                console.log('VALUES::', value);
                const companyName = value
                console.log('COMPANY NAME :', companyName)
                const response = await dispatch(checkCompanyName(companyName));
                console.log('response::', response);
                if (response.payload[0].exists !== 'No') { // Assuming true means exists
                    console.log('response payload::', response.payload[0].exists)
                    return false; // Validation fails
                }
                console.log('HEAR');
                return true; // Validation passes
            } catch (error) {
                return false; // Validation fails on error
            }

        })
        .test('english-characters-only', 'Please enter English characters only', (value) => !value || !nonEngChar.test(value))
    ,
    uPrefix: yup.string().required('Prefix cannot be empty.'),
    uFirstName: yup.string().matches(/^[a-zA-Z]+$/, 'First Name should contain only alphabets.').required('First Name cannot be empty.'),
    uLastName: yup.string().matches(/^[a-zA-Z]+$/, 'Last Name should contain only alphabets.').required('Last Name cannot be empty.'),

    companyTypeId: yup.string().required('Company Type cannot be empty.'),
    companyUrl: yup.string().url('Invalid URL format')
    .max(500, 'Company URL should not exceed 500 characters')
    // .test('valid-protocols', 'URL must start with http://, https://, or ftp://', (value) => {
    //   if (!value) return true; // Allow empty values
    //   return /^(https?|ftp):\/\//.test(value); // Check if URL starts with http://, https://, or ftp://
    // })
    // .test('checkNoSpaces', 'URL should not contain spaces', value => !/\s/.test(value))
    // .required('Company URL cannot be empty')
    ,
    companyDesc: yup.string()
        .max(400, 'Description cannot exceed 400 characters')
        .test('non-eng-char', 'Description should not contain non-English characters.', (value) => !nonEngChar.test(value))
    // .required('Company description cannot be empty.'),

})

const PersonalCompanyDetails = ({initialValues, onSubmit }) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    // const [checked, setChecked] = useState({});
    const companyTypeOptions = useSelector((state) => state.auth.companyType || []);
    const IPlistOptions = useSelector((state) => state.auth.checkIPlist || []);
    const [companyType, setCompanyType] = useState('');
    const [checkedItems, setCheckedItems] = useState({});


    const initialState = {
        uPrefix: '',
        uFirstName: '',
        uLastName: '',
        companyName: '',
        companyTypeName: '',
        companyUrl: '',
        companyDesc: '',
        companyRolesIds: '',
    }
    // const { loading } = useSelector((state) => state.auth);
    useEffect(() => {
        dispatch(getCompanyType());
    }, [dispatch]);
    // console.log('company type list values', companyTypeOptions);

    useEffect(() => {
        // Simulate fetching data from an API
        dispatch(getIntegratedPlayerList());
    }, [dispatch]);
    const IPlisthandleChange = (event) => {
        // Update the checked state for the checkbox
        const { name, checked } = event.target;
        setCheckedItems(prev => ({ ...prev, [name]: checked }));
    };
    return (
        <>

            {/* with Formik */}
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                // validationSchema={PERSONAL_COMPANY_DETAILS_VALIDATIONS (dispatch)}   
                onSubmit={(values, { setSubmitting }) => {
                    console.log('VALUESS',values)
                    const companyRolesIds = Object.keys(checkedItems)
                        .filter(key => checkedItems[key])
                        .map(key => {
                            const foundItem = IPlistOptions.find(item => item.company_rolename === key);
                            return foundItem ? foundItem.company_role_id : null;
                        })
                        .filter(id => id !== null);

                    const formattedValues = { ...values, companyRolesIds };
                    console.log('FORMATTEDVALUESS',formattedValues)
                    onSubmit(formattedValues);

                    setSubmitting(false);
                }}

            >
                {({ values, errors, handleChange, handleBlur, handleSubmit, setFieldValue, touched, actionType, isSubmitting }) => (
                    <form onSubmit={handleSubmit}>
                        <div className="row">
                            <div className="col-md-2 cs-form mb-2">
                                <FormControl className='md-input'
                                >
                                    <InputLabel id="unit-label">Prefix *</InputLabel>
                                    <Select
                                        labelId="unit-label"
                                        name="uPrefix"
                                        value={values.uPrefix}
                                        label='prefix'
                                        onChange={handleChange}
                                        error={errors.uPrefix}
                                        helperText={errors.uPrefix}
                                    >
                                        <MenuItem value="1">Ms</MenuItem>
                                        <MenuItem value="2">Mr</MenuItem>
                                        <MenuItem value="3">Mrs</MenuItem>
                                        {/* ... other units */}
                                    </Select>

                                    <FormHelperText>{touched.uPrefix && errors.uPrefix}</FormHelperText>
                                </FormControl>
                            </div>
                            <div className="col-md-5 cs-form mb-3">
                                <TextField
                                    label='First Name *'
                                    className='md-input'
                                    name='uFirstName'
                                    value={values?.uFirstName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.uFirstName}
                                    helperText={errors.uFirstName}
                                />

                            </div>

                            <div className="col-md-5 cs-form mb-3">
                                <TextField
                                    label='Last Name *'
                                    className='md-input'
                                    name='uLastName'
                                    value={values.uLastName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.uLastName}
                                    helperText={errors.uLastName}
                                />

                            </div>


                            <div className="col-md-4 cs-form mb-3">
                                <TextField
                                    label='Company name *'
                                    className='md-input'
                                    name='companyName'
                                    value={values.companyName}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.companyName}
                                    helperText={errors.companyName}
                                />
                            </div>
                            <div className="col-md-4 cs-form mb-2">
                                <FormControl className='md-input'
                                >
                                    <InputLabel id="unit-label">Company Type *</InputLabel>
                                    <Select
                                        labelId="unit-label"
                                        name="companyTypeId"
                                        label='companyType'
                                        // options={companyType}
                                        // getOptionLabel={(option) => option.label || ''}
                                        value={values.companyTypeId}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        error={errors.companyTypeId}
                                    >
                                        <MenuItem value="" disabled>Select Company Type</MenuItem>
                                        {companyTypeOptions.map((option) => (
                                            <MenuItem key={option.companyTypeId} value={option.companyTypeId}>
                                                {option.companyTypeName}
                                            </MenuItem>
                                        ))}

                                    </Select>

                                    <FormHelperText>{touched.companyTypeId && errors.companyTypeId}</FormHelperText>
                                </FormControl>
                                {values.companyTypeId === 9 && (
                                    <div>
                                        {IPlistOptions.map((item, index) => (
                                            <FormControlLabel
                                                key={index}
                                                control={
                                                    <Checkbox
                                                        checked={checkedItems[item.company_rolename] || false}
                                                        onChange={IPlisthandleChange}
                                                        name={item.company_rolename}
                                                        value={item.company_role_id}
                                                    />
                                                }
                                                label={item.company_rolename}
                                            />
                                        ))}
                                    </div>
                                    // <FormGroup>
                                    //     <FormControlLabel
                                    //         control={
                                    //             <Checkbox
                                    //                 checked={checked.spinner || false}
                                    //                 onChange={handleCheckboxChange}
                                    //                 name="spinner"
                                    //             />
                                    //         }
                                    //         label="Spinner"
                                    //     />
                                    //     <FormControlLabel
                                    //         control={
                                    //             <Checkbox
                                    //                 checked={checked.greyFabricManufacturer || false}
                                    //                 onChange={handleCheckboxChange}
                                    //                 name="greyFabricManufacturer"
                                    //             />
                                    //         }
                                    //         label="Grey Fabric Manufacturer"

                                    //     />


                                    //     <FormControlLabel
                                    //         control={
                                    //             <Checkbox
                                    //                 checked={checked.finishFabricManufacturer || false}
                                    //                 onChange={handleCheckboxChange}
                                    //                 name="finishFabricManufacturer"
                                    //             />
                                    //         }
                                    //         label="Finish Fabric Manufacturer"

                                    //     />

                                    //     <FormControlLabel
                                    //         control={
                                    //             <Checkbox
                                    //                 checked={checked.garmentManufacturer || false}
                                    //                 onChange={handleCheckboxChange}
                                    //                 name="garmentManufacturer"
                                    //             />
                                    //         }
                                    //         label="Garment Manufacturer"

                                    //     />

                                    //     {/* Add more checkboxes as needed */}
                                    // </FormGroup>
                                )}
                            </div>

                            {/* {console.log('valuess', values)} */}


                            <div className="col-md-4 cs-form mb-3">
                                <TextField
                                    label='Company URL'
                                    className='md-input'
                                    name='companyUrl'
                                    value={values.companyUrl}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.companyUrl}
                                    helperText={errors.companyUrl}
                                />
                            </div>

                            <div className="col-md-12 cs-form mb-3">
                                <TextField
                                    label='Company Description'
                                    className='md-input'
                                    name='companyDesc'
                                    multiline
                                    rows={4}
                                    value={values.companyDesc}
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    error={errors.companyDesc}
                                    helperText={errors.companyDesc}

                                />
                            </div>
                            {/* <div className="col-md-12 cs-form mb-3  ">
                            
                            </div> */}
                            <div className="d-flex justify-content-between mt-3">
                                <button type="button" className="btn btn-light grey-btn lg-btn"
                                    onClick={() => navigate(-1)}>
                                    Back
                                </button>
                                <div>

                                    <button
                                        type="submit"
                                        className="btn btn-primary greeen-btn lg-btn lg-btn"
                                        // disabled={isSubmitting}
                                    >
                                        next{/* {isSubmitting ? 'Submitting...' : 'Next'} */}

                                    </button>
                                </div>
                            </div>

                        </div>
                    </form>
                )}
            </Formik >
        </>
    )
}

export default PersonalCompanyDetails